import styled from 'styled-components';
import {
  Box,
  Divider,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  DialogContent,
} from '@mui/material';
import {
  BuildingText,
  ProjectTitle,
} from 'spw-components/projects-home/styles';
import { Row, Column, SPWDialogActions } from 'spw-shared/globalComponents';
import { colors } from 'spw-theme';

export const AddBuildingBox = styled(Box)`
  align-items: center;
  display: flex;
  font-size: 12px;
  font-style: normal;
  font-weight: bold;
  justify-content: center;
  line-height: 16px;
  width: 100%;
`;

export const OverviewBox = styled(Column)<{ selected?: boolean }>`
  && {
    width: 100%;
    height: 60px;
    cursor: pointer;
    ${(props) => props.selected && `background: ${colors.grayLight}`}
  }
`;

export const OverViewText = styled(Row)`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  align-items: center;
  color: #000000;
  flex: 1;
  margin-bottom: 0px;
  padding-left: 10px;
`;

export const OverViewSubHeaderText = styled(Row)`
  flex: 1;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  vertical-align: top;
  margin-bottom: 0px;
  color: rgba(0, 0, 0, 0.75);
  padding-left: 10px;
`;

export const OUOverviewSubheaderText = styled(OverViewSubHeaderText)`
  > :not(:last-child) {
    margin-right: 16px;
  }
`;

export const CustomDividerFloors = styled(Divider)`
  && {
    position: relative;
  }
`;

export const AccordionTitle = styled(Column)`
  padding-left: 10px;
  font-size: 18px;
`;

export const BuildingInfoBox = styled(Column)`
  padding-left: 10px;
`;

export const BuildingLocation = styled(Row)`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #000000;
`;

export const FloorCountBox = styled(Row)`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.75);
`;

export const AccordionCustom = styled(Accordion)`
  && {
    box-shadow: 0px 0px 0px 0px;
    margin: 0;
  }

  &&.Mui-expanded {
    margin: 0;
  }

  .MuiAccordionSummary-root {
    min-height: 48px;
  }

  .MuiExpansionPanelSummary-root {
    padding: 0px 0px;
  }

  .MuiExpansionPanelDetails-root {
    padding: 0px 0px;
  }

  .MuiAccordionSummary-content {
    margin: 12px 0;
  }
`;

export const FloorsContainer = styled(Column)`
  width: 100%;
`;

export const FloorBox = styled(Row)<{ selected: boolean; $disabled?: boolean }>`
  font-size: 14px;
  line-height: 20px;
  border-radius: 8px;
  width: 100%;
  height: 64px;
  padding-left: 10px;
  border-bottom: 1px solid ${colors.grayLight};
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  :hover {
    background: #eeeeee;
  }

  ${(props) => props.selected && `background: ${colors.grayLight}`}

  ${({ $disabled = false }) =>
    $disabled
      ? `&,
      &:hover {
        background: ${colors.white};
        color: ${colors.mainGray};
        cursor: auto;
        pointer-events: none;
      }`
      : ''}
`;

export const DepartmentsAndHeadcountBox = styled(Row)<{ selected: boolean }>`
  font-size: 14px;
  line-height: 20px;
  border-radius: 8px;
  width: 100%;
  height: 64px;
  border-bottom: 1px solid ${colors.grayLight};
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: flex-start;
  align-items: flex-start;
  padding: 0px 10px 0px 0px;
  cursor: pointer;

  :hover {
    background: #eeeeee;
  }

  ${(props) => props.selected && `background: ${colors.grayLight}`}
`;

export const DepartmentsText = styled(OverViewText)`
  font-weight: normal;
`;

export const ProgrammingBox = styled(Row)<{ selected: boolean }>`
  font-size: 14px;
  line-height: 20px;
  border-radius: 8px;
  width: 100%;
  height: 64px;
  padding-left: 10px;
  padding-right: 8px;
  border-bottom: 1px solid ${colors.grayLight};
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  ${(props) => props.selected && `background: ${colors.grayLight}`}
`;

export const ProgrammingBoxTextContainer = styled(Row)`
  display: flex;
  flex-direction: column;
  min-width: 50%;
`;

export const ProgrammingBoxText = styled(Row)`
  display: flex;
  flex: 1;
`;

export const ProgrammingBoxOverviewText = styled(OverViewSubHeaderText)`
  padding: 0;
`;

export const AddIconColumn = styled(Column)`
  justify-content: center;
  align-items: center;
`;

export const MoreHorizColumn = styled(Column)`
  justify-content: center;
  align-items: center;
`;

export const FloorName = styled(Column)`
  font-size: 14px;
  width: 100%;
  cursor: pointer;
`;

export const BuildingTitleMaxWidth = styled(ProjectTitle)`
  width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;
`;

export const BuildingTextDefaultCursor = styled(BuildingText)`
  cursor: default;
`;

export const ButtonContainer = styled.div`
  && {
    display: flex;
    justify-content: flex-end;
    width: 20%;
  }
`;

export const AccordionDetailsCustom = styled(AccordionDetails)`
  && {
    padding: 8px 16px 16px 0;
  }
`;

export const AccordionSummaryCustom = styled(AccordionSummary)`
  && {
    padding: 0 16px 0 0;
  }
`;

export const ProgramSummaryLeftNavHeader = styled(AccordionSummary)`
  && {
    padding: 0 16px 0 0;
    border-bottom: 1px solid ${colors.grayDivider};
    cursor: initial !important;
  }
`;

export const BuildingDetailsLeftNavDetails = styled(AccordionDetails)`
  && {
    padding: 0px 16px 0px 0;
  }
`;

export const BuildingDetailsLeftNavHeader = styled(AccordionSummary)`
  && {
    padding: 0 16px 0 0;
    cursor: initial !important;
  }
`;

export const AccordionSummaryHover = styled(AccordionSummary)`
  &&.MuiAccordionSummary-root {
    border-bottom: 1px solid ${colors.white};
  }

  :hover {
    background: ${colors.backgroundGrey};
  }

  &&.MuiAccordionSummary-root.Mui-expanded {
    border-top: 1px solid ${colors.grayDivider};
    background: ${colors.grayLight};
  }
`;

export const LoadingBox = styled(Box)`
  && {
    margin-top: 20px;
    text-align: center;
  }
`;

export const BuildingTitleBox = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 40px;
`;

export const FloorDialogContent = styled(DialogContent)`
  &.MuiDialogContent-root:first-child {
    padding-top: 24px;
  }
`;

export const FloorDialogActions = styled(SPWDialogActions)`
  & button {
    width: 88px;
  }
`;
